<template>
  <div class="chat-container w-100 position-relative">
    <span id="merchant"></span>
    <div class="my-5 text-center" v-if="is_load">
      <loader />
    </div>
    <template v-else>
      <div class="my-4" v-if="error != ''">
        <ErrorMessage :message="error" />
      </div>
      <template v-else>
        <!-- IMAGES -->
        <div class="w-100 position-relative">
          <img src="../../../../assets/img/icon/back-white.png" @click="backToList" class="p-2 rounded-10 mt-3 ml-4 cursor-pointer position-absolute" height="40" style="z-index: 1049;background-color:#0000008c">
          <div class="w-100" style="height: 250px !important;" v-if="merchant.merchant_images.length == 0">
            <img :src="merchant.image_url" class="img-fit" height="150">
          </div>
          <div class="mb-2" v-else>
            <flickity ref="flickity" :options="flickityOptions">
              <template v-for="slider_merchant in  merchant.merchant_images">
                <div class="carousel-cell w-100" id="carousel-cell1" v-if="slider_merchant.image_type == 'SLIDER'">
                  <div class="w-100" style="height: 250px !important;" >
                    <img :src="slider_merchant.image_url" class="img-fit" height="150">
                  </div>
                </div>
              </template>
            </flickity>
          </div>
        </div>

        <!-- TITLE -->
        <div class="container">
          <div class="px-2 pt-3 pb-2">
            <p class="mb-0 heading-5 text-color-dark">{{merchant.name}}</p>
            <template v-if="merchant_area != ''">
              <img src="../../../../assets/img/icon/location.png" class="d-inline-block" width="10">
              <p class="mb-0 d-inline-block ml-1 body-2-2-1">{{merchant_area}}</p>
            </template>
          </div>
        </div>

        <!-- AVAILABLE DAY -->
        <div class="container my-2" style="background-color: #F6FAF0">
          <div class="px-2 pt-3 pb-2">
            <div class="d-block">
              <img src="../../../../assets/img/icon/calendar.png" class="d-inline-block mr-2" width="16">
              <p class="d-inline-block body-2-4 text-black mb-2" v-if="is_today_available">{{$t('merchant.available-today')}}</p>
              <p class="d-inline-block body-2-4 text-danger mb-2" v-else>{{$t('merchant.today-is-close')}}</p>
              <div class="d-block mt-2 ml-4" v-if="opening_days">
                <div class="w-100 mb-2" v-if="merchant.sale_sunday">
                  <span class="dot-green ml-2 mr-1 d-inline-block align-middle"></span><p class="mb-0 body-2-2 pl-2 d-inline-block align-middle">{{$t('general.days.sunday')}}</p>
                </div>
                <div class="w-100 mb-2" v-if="merchant.sale_monday">
                  <span class="dot-green ml-2 mr-1 d-inline-block align-middle"></span><p class="mb-0 body-2-2 pl-2 d-inline-block align-middle">{{$t('general.days.monday')}}</p>
                </div>
                <div class="w-100 mb-2" v-if="merchant.sale_tuesday">
                  <span class="dot-green ml-2 mr-1 d-inline-block align-middle"></span><p class="mb-0 body-2-2 pl-2 d-inline-block align-middle">{{$t('general.days.tuesday')}}</p>
                </div>
                <div class="w-100 mb-2" v-if="merchant.sale_wednesday">
                  <span class="dot-green ml-2 mr-1 d-inline-block align-middle"></span><p class="mb-0 body-2-2 pl-2 d-inline-block align-middle">{{$t('general.days.wednesday')}}</p>
                </div>
                <div class="w-100 mb-2" v-if="merchant.sale_thursday">
                  <span class="dot-green ml-2 mr-1 d-inline-block align-middle"></span><p class="mb-0 body-2-2 pl-2 d-inline-block align-middle">{{$t('general.days.thursday')}}</p>
                </div>
                <div class="w-100 mb-2" v-if="merchant.sale_friday">
                  <span class="dot-green ml-2 mr-1 d-inline-block align-middle"></span><p class="mb-0 body-2-2 pl-2 d-inline-block align-middle">{{$t('general.days.friday')}}</p>
                </div>
                <div class="w-100 mb-2" v-if="merchant.sale_saturday">
                  <span class="dot-green ml-2 mr-1 d-inline-block align-middle"></span><p class="mb-0 body-2-2 pl-2 d-inline-block align-middle">{{$t('general.days.saturday')}}</p>
                </div>
              </div>
            </div>
            <div class="row grid-slim-row" v-if="!is_everyday_close">
              <div class="col-1">
              </div>
              <div class="col-9">
                <p class="d-inline-block body-2-4 my-2 text-green" @click="opening_days = !opening_days">
                  <template v-if="opening_days">
                    {{$t('general.close')}}
                  </template>
                  <template v-else>
                    {{$t('merchant.see-all-opening-days')}}
                  </template>
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- WHATSAPP -->
        <div class="container mt-4 mb-2">
          <whatsappLink :name="merchant.name" :description="$t('hotel.concierge.fitur.ask-the-hotel-about-this-package')" />
        </div>

        <!-- HIGHLIGHT -->
        <div class="container pt-3 mb-2" v-if="merchant.highlights != null">
          <div class="px-2">
            <p class="heading-5 text-black mb-1">{{$t('merchant.highlights')}}</p>
            <p class="d-inline-block body-2-2-1 mb-1" v-html="merchant.highlights"></p>
          </div>
        </div>

        <!-- EXPERIENCE -->
        <div class="container pt-3 mb-2" v-if="merchant.experience != null">
          <div class="px-2">
            <p class="heading-5 text-black mb-1">{{$t('merchant.what-you-will-experience')}}</p>
              <p class="body-2-2-1" v-html="merchant.experience"></p>
          </div>
        </div>

        <!-- FACILITIES -->
        <div class="container pt-3 mb-2" v-if="merchant.facilities.length != 0">
          <div class="px-2">
            <p class="heading-5 text-black mb-2">{{$t('merchant.facilities')}}</p>
            <div class="mb-2">
              <div v-if="merchant.facilities.length > 5" class="d-inline-block text-left position-relative mobile-none" style="top: -30px;" @click="scrollLeftReview">
                <img src="../../../../assets/img/icon/down-arrow.png" width="20" style="transform: rotate(90deg);">
              </div>
              <div class="div-wrappers mx-auto m-width-100" :class="{'d-inline-block' : merchant.facilities.length > 5}" style="width: 88%;">
                <div class="text-center mx-auto" style="width: max-content">
                  <div class="width-50 text-center d-inline-block align-bottom" v-for="facilities in merchant.facilities">
                    <i :class="facilities.icon"></i>
                    <p class="body-p pt-1 mb-0">{{facilities.name}}</p>
                  </div>
                </div>
              </div>
              <div v-if="merchant.facilities.length > 5" class="d-inline-block text-right position-relative mobile-none" style="top: -30px;" @click="scrollRightReview">
                <img src="../../../../assets/img/icon/down-arrow.png" width="20" style="transform: rotate(-90deg);">
              </div>
            </div>
          </div>
        </div>

        <!-- GALLERY -->
        <div v-if="merchant.merchant_images.length > 0" class="container pb-4 border-bottom mb-2 pt-3">
          <div class="px-2">
            <p class="heading-5 text-black mb-1">{{$t("restaurant.menu.gallery")}}</p>
            <p class="mb-3 body-2-2">{{$t("hotel.concierge.fitur.experience.tap-to-see-detail-of-image")}}</p>
            <div class="row slim-grid-row-1">
              <template v-for="gallery in merchant.merchant_images">
                <div class="col-3 mb-2" v-if="gallery.image_type == 'GALLERY'">
                  <div class="w-100 rounded-3" style="overflow:hidden">
                    <img :src="gallery.image_url" class="cursor-pointer object-fit rounded-3 w-100 img-hover-zoom-in" height="90" @click="detail_data=gallery">
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>

        <!-- ADDRESS -->
        <div class="container pt-3 mb-2">
          <div class="px-2">
            <p class="heading-5 text-black mb-1">{{$t('merchant.location-detail')}}</p>
              <p class="body-2-2-1">{{merchant.address}}</p>
          </div>
        </div>
        <div class="mb-5 w-100" v-if="merchant.latitude != 0 && merchant.longitude != 0">
          <gmap-map v-if="map.center.lat != null" :center="map.center" :zoom="15" style="width:100%;  height: 250px;">
              <gmap-marker :key="index" v-for="(m, index) in map.markers" :position="m.position"></gmap-marker>
          </gmap-map>
        </div>

        <!-- HOW TO REDEEM -->
        <div class="container pt-2 mb-2 border-bottom" @click="toggleData('redeem')" v-if="merchant.how_to_redeem != null">
          <div class="px-2 ">
            <div class="row">
              <div class="col-10">
                <p class="text-left d-inline-block sub-heading-1-1 text-black">{{$t('merchant.how-to-redeem')}}</p>
              </div>
              <div class="col-1">
                <img src="../../../../assets/img/icon/down-arrow.png" :class="{'rotate-180': toggle_data == 'redeem'}" class="d-inline-block text-right" width="18">
              </div>
            </div>
          </div>
          <transition name="list">
          <div class="px-4" v-if="toggle_data == 'redeem'">
            <p class="body-2-2-1" v-html="merchant.how_to_redeem"></p>
          </div>
          </transition>
        </div>

        <!-- TERMS AND CONDITIONS -->
        <div class="container pt-2 mb-2 border-bottom" @click="toggleData('term')" v-if="merchant.terms_and_conditions != null">
          <div class="px-2 ">
            <div class="row">
              <div class="col-10">
                <p class="text-left d-inline-block sub-heading-1-1 text-black">{{$t('merchant.term-condition')}}</p>
              </div>
              <div class="col-1">
                 <img src="../../../../assets/img/icon/down-arrow.png" :class="{'rotate-180': toggle_data == 'term'}" class="d-inline-block text-right" width="18">
              </div>
            </div>
          </div>
          <transition name="list">
            <div class="px-4" v-if="toggle_data == 'term'">
              <p class="body-2-2-1" v-html="merchant.terms_and_conditions"></p>
            </div>
          </transition>
        </div>

        <!-- CANCELLATION POLICY-->
        <div class="container pt-2 mb-2 border-bottom" @click="toggleData('cancel')" v-if="merchant.cancellation_policy != null">
          <div class="px-2 ">
            <div class="row">
              <div class="col-10">
                <p class="text-left d-inline-block sub-heading-1-1 text-black">{{$t('merchant.cancellation-policy')}}</p>
              </div>
              <div class="col-1">
                 <img src="../../../../assets/img/icon/down-arrow.png" :class="{'rotate-180': toggle_data == 'cancel'}" class="d-inline-block text-right" width="18">
              </div>
            </div>
          </div>
          <transition name="list">
            <div class="px-4" v-if="toggle_data == 'cancel'">
              <p class="body-2-2-1" v-html="merchant.cancellation_policy"></p>
            </div>
          </transition>
        </div>

        <!-- MARGIN -->
        <div class="mb-5 pt-4" style="height:20px"></div>
        
        <!-- NAVBAR -->
        <div class="py-0 fixed-bottom z-index-1028">
          <div class="w-100">
            <b-row class="justify-content-center" no-gutters>
              <b-col cols="12" sm="8" md="6" lg="4" xl="4" class="py-2 bg-white border-top">
                <div class="w-100">
                  <b-row no-gutters>
                    <div class="container px-4 bg-white">
                      <div class="row">
                        <div class="col-6">
                          <p class="mb-0 body-3-3-1 text-black pt-2" style="margin-bottom: -7px !important;">{{$t('merchant.starting-from')}}</p>
                          <p class="mb-1 mt-2 sub-heading-1-2 text-color-orange">{{formatCurrency(merchant.best_price)}}</p>
                        </div>
                        <div class="col-6">
                          <router-link :to="'/'+getMerchant.code+'/concierge/experience/'+merchant_child_id+'/list'">
                            <p class="mb-0 body-2-4 text-white bg-orange text-center mx-auto radius-12 " style="padding-top: 13px;padding-bottom: 13px;margin-top: 6px">Find Services</p>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>


        <!-- IMAGE DETAIL -->
        <transition name="fade">
          <template v-if="detail_data != null">
            <div class="position-relative" style="z-index: 1039">
              <div class="row no-gutters justify-content-center">
                <div class="fixed-bottom d-block nav-bottom" style="bottom:0%;top: 0">
                  <div class="custom-container-fluid px-0">
                    <div class="row justify-content-center no-gutters">
                      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                        <div class="bg-black">
                          <div class="w-100 popup-full">
                            <img src="../../../../assets/img/icon/cancel.png" class="d-inline-block rounded-3 bg-back mt-3 mx-3 cursor-pointer position-absolute" width="40" style="z-index: 1049;right: 10px;top:8px;padding:11px" @click="detail_data=null">
                            <div class="w-100 pb-5">
                              <img :src="detail_data.image_url" class="w-100 experience-gallery-img">
                              <div class="experience-gallery-title">
                                <p class="mb-0 body-3-3 text-14 font-regular text-white">{{detail_data.title}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </transition>
      </template>
    </template>
    <!-- <BottomNavbar></BottomNavbar> -->
  </div>
</template>
<script type="text/javascript">
  import {get} from '@/services/index.js'
  import {customFormatDateTime,formatCurrency} from '@/utils/index.js'
  import {mapGetters, mapMutations} from "vuex";
  import Flickity from 'vue-flickity';
  import BottomNavbar from '@/components/hotel/BottomNavbar';
  import whatsappLink from '@/components/hotel/concierge/general/whatsappLink';
  import moment from 'moment';

  export default {
    components: {
      Flickity,
      BottomNavbar,
      whatsappLink
    },
    metaInfo(){
      let title = Object.keys(this.merchant).length > 0 ? this.merchant.name : this.$t("hotel.concierge.fitur.experience.things-to-do")
      return {title}
    },
    data() {
      return {
        flickityOptions: {
          initialIndex: 0,
          autoPlay: 2500,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          draggable: true,
        },
        scrollPosition: null,
        is_load: true,
        merchant: {},
        error: '',
        merchant_area: '',
        is_today_available: false,
        is_everyday_close: true,
        opening_days: false,
        toggle_data: '',
        map:{
          center: { lat: null, lng: null },
          markers: []
        },
        action_success:{
          show: false,
          message: '',
          timer: 0
        },
        detail_active: '',
        detail_data: null,      
      }
    },
    computed:{
      ...mapGetters(['getMerchant']),
      show_success(){
        return this.action_success.show
      },
      merchant_child_id(){
        return this.$route.params.id
      }
    },
    watch:{
      show_success(){
        if (this.action_success.show) {
          let looping = setInterval(() => {
            if (this.action_success.timer > 0) {
              this.action_success.timer--
            }else if(this.action_success.timer == 0){
              this.action_success.show = false
              this.action_success.message = ''
              clearInterval(looping)
            }
          },1000) 
        }
      }
    },
    mounted() {
      document.getElementById('merchant').scrollIntoView({
          behavior: 'smooth'
      });
      window.addEventListener('scroll', this.updateScroll);
      this.loadFirstData()
    },
    methods: {
      // GENERAL
      ...mapMutations(['resetConciergeOrder']),
      toggleData(data) {
        if (this.toggle_data == data) {
          this.toggle_data = ''
        }else{
          this.toggle_data = data
        }
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      formatHour(time){
        return customFormatDateTime(time, 'HH:mm:ss', 'HH:mm')
      },
      checkIfTodayIsOpen(){
        let today = moment().format("d")
        switch(today){

          case '0' :
            if (this.merchant.sale_sunday)
              this.is_today_available = true
            else
              this.is_today_available = false
            break;

          case '1' :
            if (this.merchant.sale_monday)
              this.is_today_available = true
            else
              this.is_today_available = false
            break;

          case '2' :
            if (this.merchant.sale_tuesday){
              this.is_today_available = true
            }
            else{
              this.is_today_available = false
            }
            break;

          case '3' :
            if (this.merchant.sale_wednesday)
              this.is_today_available = true
            else
              this.is_today_available = false
            break;

          case '4' :
            if (this.merchant.sale_thursday)
              this.is_today_available = true
            else
              this.is_today_available = false
            break;

          case '5' :
            if (this.merchant.sale_friday)
              this.is_today_available = true
            else
              this.is_today_available = false
            break;

          case '6' :
            if (this.merchant.sale_saturday)
              this.is_today_available = true
            else
              this.is_today_available = false
            break;

          default :
            this.is_today_available = false
        }
      },
      scrollLeftReview() {
        let content = document.querySelector(".div-wrappers");
        content.scrollLeft -= 80;
      },
      scrollRightReview() {
        let content = document.querySelector(".div-wrappers");
        content.scrollLeft += 80;
      },
      shareClick(){
        var value = window.location.href;
        var input_temp = document.createElement("input");
        input_temp.value = value;
        document.body.appendChild(input_temp);
        input_temp.select();
        document.execCommand("copy");
        document.body.removeChild(input_temp);
        this.action_success.show = true
        this.action_success.message = 'Link ('+value+') Copied'
        this.action_success.timer = 2
      },
      stopLoadData(msg=''){
        this.is_load = false
        this.error = msg
      },
      backToList(){
        this.$router.push(`/${this.getMerchant.code}/concierge/experience`)
      },


      // API
      loadMerchantData(){
        return new Promise(done=>{
          get("CONCIERGE","experience/merchant/"+this.merchant_child_id,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.merchant = res.data
              done(true)
            }else{
              done(res.message)
            }
          })
        })
      },
      loadMerchantArea(data){
        get("CORE","user-location",{
          lat: data.latitude,
          long: data.longitude
        }).then(response=>{
          if(response.data.success){
            let location_type = response.data.data.address_components
            for(let i = 0; i < location_type.length;i++){
                if (location_type[i].types[0] == 'administrative_area_level_3') {
                    this.merchant_area = location_type[i].short_name;
                    break;
                }
            }
          }
        })
      },
      loadFirstData(){
        this.is_load = true
        this.error = ''
        this.loadMerchantData().then(merchant_response=>{
          if(merchant_response == true){
            this.resetConciergeOrder()
            if(this.merchant.latitude != 0 && this.merchant.longitude != 0){
              this.loadMerchantArea(this.merchant)
            }
            this.checkIfTodayIsOpen()
            if(
              this.merchant.sale_sunday || 
              this.merchant.sale_monday || 
              this.merchant.sale_tuesday || 
              this.merchant.sale_wednesday || 
              this.merchant.sale_thursday || 
              this.merchant.sale_friday || 
              this.merchant.sale_saturday
              ){
                this.is_everyday_close = false
            }
            this.map.center = {
              lat : this.merchant.latitude,
              lng : this.merchant.longitude
            }
            this.map.markers = []
            this.map.markers.push({ position: this.center });
            this.stopLoadData()
          }else{
            this.stopLoadData(merchant_response)
          }
        })
      },
    }
  }

</script>
<style scoped>
  .rotate-180{
    transform: rotate(180deg);
  }
  .pop-up{
    height: 100vh;
    overflow: scroll;
  }

  .flickity-page-dots .dot{
    background-color: #79a33a !important;
  }

  .review-img{
    border-radius: 50%;
    object-fit: cover;
  }

  .object-fit{
    object-fit: cover;
  }

  .slide-review{
    height: auto !important;
  }

  .list-enter,
  .list-leave-to {
    visibility: hidden;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 0.3s;
  }

  .slide-detail{
    display: inline-block;
    width: 100px;
    height: 100px;
  }

  .text-black {
    color: #000 !important;
  }

  .body-p {
    font-size: 10px;
    font-family: Nunito-Regular;
    color: #9BA1AA;
    letter-spacing: 0.25px;
  }

  .width-50 {
    width: 50px !important;
    height: 55px;
    margin: 0 8px;
  }

  .div-wrapper {
    overflow-x: auto;
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }

  .div-wrapper::-webkit-scrollbar {
      display: none !important;
  }

  .div-wrappers {
    overflow-x: auto;
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }

  .div-wrappers::-webkit-scrollbar {
      display: none !important;
  }
  
  @media screen and (max-width: 600px) {
    
    .m-width-100{
      width: 100% !important;
    }

    .mobile-none{
      display: none !important;
    }

  }
  
</style>



// WEBPACK FOOTER //
// src/pages/hotel/concierge/thingstodo/MerchantDetail.vue